var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "youtube_svg__a",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6896_37304"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0287811 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_6896_37304",
    result: "effect2_dropShadow_6896_37304"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_6896_37304",
    result: "effect3_dropShadow_6896_37304"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_6896_37304",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "youtube_svg__currentLayer"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.329 45.162a8.645 8.645 0 01-2.445-2.43 9.016 9.016 0 01-1.34-3.228 79.167 79.167 0 01-.03-30.967A8.941 8.941 0 012.84 5.33c1.333-1.985 3.365-3.344 5.654-3.782a79.218 79.218 0 0130.972-.037l-.004.008a8.858 8.858 0 013.214 1.322 8.675 8.675 0 012.441 2.433 9.046 9.046 0 011.34 3.229 79.225 79.225 0 01.03 30.964 8.895 8.895 0 01-1.327 3.208c-1.335 1.985-3.368 3.344-5.66 3.781a79.236 79.236 0 01-30.966.035 8.85 8.85 0 01-3.206-1.328z",
    fill: "#00A1DC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.123 18.015V28.82l11.14-5.013-11.14-5.793z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.92 35.99c5.265-.132 10.517-.972 11.966-2.313 2.69-2.491 2.631-17.097 0-19.593-1.435-1.362-6.664-2.068-11.923-2.074l.35-.002c-5.26.006-10.763.714-12.199 2.076-2.631 2.496-2.69 17.102 0 19.593 1.449 1.341 6.7 2.181 11.966 2.313",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
export default SvgYoutube;